import { Dispatch } from "react"
import { statusPaymentModeStart, statusPaymentModeSuccess, statusPaymentModeFailure } from "./paymentModeSlice"
import { get, post, put, remove } from "../../requestMethods"

export const ShowPaymentModeApi = (store: string = "") => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusPaymentModeStart())
    const response = await get(`paymentMode/${store}`)
    const resData = response.data.success
    if(resData) {
      dispatch(statusPaymentModeSuccess(resData))
      return true
    }
  } catch (error: any) {
    const errData = error.response.data
    if(errData && error.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData]
      dispatch(statusPaymentModeFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusPaymentModeFailure([errData.err]))
      return [errData.err]
    }
  }
}

export const AddPaymentModeApi = (store: any, data: {}) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusPaymentModeStart())
    let response = await post(`paymentMode/${store}`, data)
    const resData = response.data.success
    if(resData) {
      dispatch(statusPaymentModeSuccess(resData))
      return true
    }
  } catch (error: any) {
    const errData = error.response.data
    if(errData && error.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData]
      dispatch(statusPaymentModeFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusPaymentModeFailure([errData.err]))
      return [errData.err]
    }
  }
}

export const EditPaymentModeApi = (store: any, treatId: string, data: {}) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusPaymentModeStart())
    let response = await put(`paymentMode/${store}/${treatId}`, data)
    const resData = response.data.success
    if(resData) {
      dispatch(statusPaymentModeSuccess(resData))
      return true
    }
  } catch (error: any) {
    const errData = error.response.data
    if(errData && error.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData]
      dispatch(statusPaymentModeFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusPaymentModeFailure([errData.err]))
      return [errData.err]
    }
  }
}

export const DeletePaymentModeApi = (store: any, treatId: string) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusPaymentModeStart())
    let response = await remove(`paymentMode/${store}/${treatId}`)
    const resData = response.data.success
    if(resData) {
      dispatch(statusPaymentModeSuccess(resData))
      return true
    }
  } catch (error: any) {
    const errData = error.response.data
    if(errData && error.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData]
      dispatch(statusPaymentModeFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusPaymentModeFailure([errData.err]))
      return [errData.err]
    }
  }
}

export const clearPaymentModeApi = async (dispatch: Dispatch<any>) => {
  dispatch(statusPaymentModeSuccess([]))
}
